import { render, staticRenderFns } from "./pay-card.vue?vue&type=template&id=0dd59a07&scoped=true"
import script from "./pay-card.vue?vue&type=script&lang=js"
export * from "./pay-card.vue?vue&type=script&lang=js"
import style0 from "./pay-card.vue?vue&type=style&index=0&id=0dd59a07&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd59a07",
  null
  
)

export default component.exports